/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deploymentsList } from "../funcs/deploymentsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDeploymentResult } from "../models/components/listdeploymentresult.js";
import {
  ListDeploymentsRequest,
  ListDeploymentsSecurity,
} from "../models/operations/listdeployments.js";
import { unwrapAsync } from "../types/fp.js";
export type ListDeploymentsQueryData = ListDeploymentResult;

export function prefetchListDeployments(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDeploymentsRequest | undefined,
  security?: ListDeploymentsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListDeploymentsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListDeploymentsQuery(
  client$: GramCore,
  request?: ListDeploymentsRequest | undefined,
  security?: ListDeploymentsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListDeploymentsQueryData>;
} {
  return {
    queryKey: queryKeyListDeployments({
      cursor: request?.cursor,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listDeploymentsQueryFn(
      ctx,
    ): Promise<ListDeploymentsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deploymentsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListDeployments(
  parameters: {
    cursor?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deployments", "list", parameters];
}
